import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

// Track page views
export const trackPageView = (pageName) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  // Analytics is best-effort; a blocked or unavailable SDK must not break a link.
  try {
    if (analytics) logEvent(analytics, eventName, parameters);
  } catch { /* Keep the user's action working without analytics. */ }
};

// Track button clicks
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location
  });
};

// Track app downloads
export const trackAppDownload = (appName, platform = '') => {
  trackEvent('app_download', {
    app_name: appName,
    platform: platform
  });
};
